import { Component, OnInit, Pipe, PipeTransform  } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-join-meeting',
  templateUrl: './join-meeting.component.html',
  styleUrls: ['./join-meeting.component.scss']
})
export class JoinMeetingComponent implements OnInit {
  @Pipe({ name: 'safe' })
  joinMeetingForm: FormGroup;
  result:any; 
  pdata:any; 
  pat_id:any;
  cons_id:any;
  joinData:any; 

  //doctor details
  d_name :any
  d_gender :any //gender and age in years and days    
  d_blood_group :any
  d_marital_status :any
  d_email :any
  // d_phone :any

//consulation details
  cons_date_time :any //cons date and time
  cons_type :any  

//vital signs
  pulse_rate :any
  blood_pressure :any
  temperature :any
  glucose :any
  hemoglobin :any
  ecg_monitor :any
  height :any
  weight :any

  //other info
  complaints_data:any
  symptoms_data:any
  diseases_data:any
  allergys_data:any
  under_bp_medication :any
  under_sugar_medication :any
 
  firstName:any;

  vcData:any; 
  urlSafe: SafeResourceUrl;
  consult_id;
  patient_id;
  meeting: any;

  constructor(private sanitizer:DomSanitizer,private fb: FormBuilder,public router:Router,private serviceService: ServiceService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.serviceService.get_meetingId()
  .subscribe((data) => {
    this.meeting = data;
    this.joinMeetingForm.controls['meeting_id'].setValue(this.meeting.meeting_id);
    console.log("Datar", this.meeting)
  })
    this.firstName=localStorage.getItem('firstName');
    this.joinMeetingForm = this.fb.group({
      meeting_id:['', [Validators.required,this.alphaNumValidator]]
        
    });

  }

  public checkError = (controlName: string, errorName: string) => {
    return this.joinMeetingForm.controls[controlName].hasError(errorName);
  }

  alphaNumValidator(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\/, ''/]/;    
  
    if (control.value && nameRegexp.test(control.value)) {
      return { alphaNumCheck: true };
    }
  }

  calculateBMI(): string {
    if (this.height && this.weight) {
      // Convert height from cm to meters (1 cm = 0.01 m)
      const heightInMeters = this.height / 100;

      // Calculate BMI
      const bmi = this.weight / (heightInMeters * heightInMeters);

      // Format BMI to display in metric square
      return bmi.toFixed(2) + ' kg/m²';
    }
    // Return an empty string or an appropriate message if height or weight is missing.
    return 'N/A';
  }

  joinMeeting()
  { 
    if(this.joinMeetingForm.invalid){
      return
    } 
       
   
   var passdata={
     meetingId:this.joinMeetingForm.value.meeting_id,
     patientName:this.firstName
 }

   

  //join meeting
   this.serviceService.joinMeeting(passdata)
   .subscribe((data) => {
   this.joinData=data;   
   console.log("join url: " +JSON.stringify(this.joinData.joinMeetingUrl));
   this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.joinData.joinMeetingUrl);    

   });
    
    
    //get doctor detail
    this.serviceService.GetConsult_Meeting_Doctor(passdata.meetingId)
      .subscribe((data) => {
        this.result = data;

        //patient details
        this.d_name = this.result[0].d_name;
        this.d_gender = this.result[0].d_gender;
        this.d_email = this.result[0].d_email;
        // this.d_phone = this.result[0].d_phone;

        //consulation details
        this.cons_date_time = this.result[0].cons_date_time; //cons date and time
        this.cons_type = this.result[0].cons_type;

        //vital signs

        this.pulse_rate = this.result[0].pulse_rate;
        this.blood_pressure = this.result[0].blood_pressure;
        this.temperature = this.result[0].temperature;
        this.glucose = this.result[0].glucose;
        this.hemoglobin = this.result[0].hemoglobin;
        this.ecg_monitor = this.result[0].ecg_monitor;
        this.height = this.result[0].height;
        this.weight = this.result[0].weight;


        //other info

        this.complaints_data = this.result[0].complaintslist;
        this.symptoms_data = this.result[0].symptomslist;
        this.diseases_data = this.result[0].medicationlist;
        this.allergys_data = this.result[0].allergylist;
        this.under_bp_medication = this.result[0].under_bp_medication;
        this.under_sugar_medication = this.result[0].under_sugar_medication;


      }); 

 }

//  bind(){
//   this.joinMeetingForm.controls['meeting_id'].setValue(this.data.meeting_id);
//  }


}
